module.exports = __webpack_public_path__ + "static/client19-35f359796581ff497cf5f461b8d4c4de.png";